import { render, staticRenderFns } from "./producer_submit_summary.vue?vue&type=template&id=ee956d76&scoped=true"
import script from "./producer_submit_summary.vue?vue&type=script&lang=js"
export * from "./producer_submit_summary.vue?vue&type=script&lang=js"
import style0 from "./producer_submit_summary.vue?vue&type=style&index=0&id=ee956d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee956d76",
  null
  
)

export default component.exports